/**
 * Axios may serialize config.data to a JSON string before the gRPC adapter runs.
 * Normalize to a plain object for Create/Update builders.
 */
export function parseRequestBody(data) {
    if (data == null) {
        return {};
    }
    if (typeof data === 'string') {
        const trimmed = data.trim();
        if (!trimmed) {
            return {};
        }
        try {
            const parsed = JSON.parse(trimmed);
            return parsed && typeof parsed === 'object' ? parsed : {};
        } catch {
            return {};
        }
    }
    if (typeof data === 'object' && !(data instanceof FormData)) {
        return data;
    }
    return {};
}
